import React from 'react';
import { Button } from 'antd';


const ModalFooterButton = ({ loading, label }) => {
    return (
        <>
            <br/>
            <div
                style={{
                    paddingTop: 14,
                    margin: '0 -24px -14px',
                    textAlign: 'right',
                    borderTop: '1px solid #e8e8e8',
                }}
            >
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    style={{ marginRight: 16 }}
                >
                    { label }
                </Button>
            </div>
        </>
    );
};

export default ModalFooterButton;
